<template>
  <div class="ab__list">
    <div class="box-layout a-page__info clearfix">
      <div class="label">
        <p class="emphasis style1">A</p><span>Page</span>
      </div>

      <div class="info">
        <p class="name">{{ applyData.pageName }}</p>
        <p class="url">{{ applyData.url }}</p>
      </div>
    </div>

    <div class="box-layout b-page__list clearfix">
      <div class="label">
        <p class="emphasis style2">B</p><span>Pages</span>
      </div>

      <div class="button--wrap">
        <template v-if="!isShared">
          <!-- register button -->
          <ui-button v-if="!isFullTraffic"
                     primary
                     iconName="icon--plus-white"
                     :disabled="userData.creditEmpty"
                     :to="{name: 'ab.add', params: routeParams}">{{ $t('common.addPage') }}</ui-button>
          <!-- register button & traffic max -->
          <ui-button v-else
                     primary
                     iconName="icon--plus-white"
                     :disabled="userData.creditEmpty"
                     @click="onAlertFullTraffic">{{ $t('common.addPage') }}</ui-button>
          <!-- tracking -->
          <ui-button iconName="icon--tracking-code" class="btn__tracking-code"
                     @click="showTrackingCode = true">{{ $t('common.trackingCode.title') }}</ui-button>
        </template>
      </div>

      <ABtestListTable :abPageList="abPageList"/>
    </div>

    <!-- 트래킹 코드 -->
    <TrackingCodeConfirm
      v-if="showTrackingCode"
      @closePopup="showTrackingCode = false"
      :sid="applyData.sid"/>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import TrackingCodeConfirm from '@/components/dashboard/TrackingCodeConfirm'
import ABtestListTable from '@/components/report-ab/ABtestListTable'
import AppDialog from '@/components/ui/AppDialog'
import UiButton from '@/components/ui/UiButton'
import { create } from 'vue-modal-dialogs'

const alertFullTraffic = create(AppDialog, 'dialogType')

export default {
  components: {
    TrackingCodeConfirm,
    ABtestListTable,
    UiButton
  },
  props: [
    'applyData',
    'abPageList'
  ],
  data () {
    return {
      showTrackingCode: false,
      creditEmpty: false
    }
  },
  computed: {
    ...mapState([
      'userData'
    ]),
    ...mapGetters([
      'abUsedTraffic'
    ]),
    routeParams () {
      return {
        aid: this.$route.params.aid
      }
    },
    isFullTraffic () {
      return this.abUsedTraffic === 100
    },
    isShared () {
      return this.applyData.meta.shared
    }
  },
  methods: {
    onAlertFullTraffic () {
      alertFullTraffic('abReport.pageList.notExistingAvailableTraffic')
    }
  }
}
</script>

<style lang="scss" scoped>
.ab__list {
  margin-top: 30px;

  .box-layout {
    width: 100%;
    border-radius: 14px;
    box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.08);
    background-color: #ffffff;
    margin-top: 30px;
    padding: 20px;
    box-sizing: border-box;

    .label {
      .emphasis {
        display: inline-block;
        width: 38px;
        height: 38px;
        line-height: 38px;
        border-radius: 5px;
        font-size: 20px;
        font-weight: bold;
        color: #ffffff;
        text-align: center;
        margin-right: 10px;

        &.style1 {
          background-color: #9fce12;
        }
        &.style2 {
          background-color: #1199af;
        }

        & + span {
          font-size: 16px;
          font-weight: bold;
          color: #2f2f2f;
        }
      }
    }
  }

  .a-page__info {
    display: flex;
    justify-content: flex-start;
    height: 109px;

    .info {
      text-align: left;
      margin-top: 12px;
      margin-left: 15px;
      .name {
        padding-left: 15px;
        font-size: 14px;
        color: #2f2f2f;
        position: relative;
        &:before {
          content: '';
          display: inline-block;
          width: 1px;
          height: 12px;
          @include positionYcenter;
          left: 0;
          border-left: 1px solid #d7d7d7;
        }
      }
      .url {
        padding-left: 15px;
        font-size: 13px;
        color: #666;
        margin-top: 15px;
      }
    }
  }

  .b-page__list {
    position: relative;

    .title {
      font-size: 15px;
      font-weight: bold;
      line-height: 1;
      color: #2f2f2f;
    }

    .button--wrap {
      position: absolute;
      top: 20px;
      right: 20px;

      button {
        &.btn__tracking-code {
          margin-left: 5px;
        }
      }
    }

    .page__list {
      margin-top: 53px;
      height: 100px;
      background-color: #5c5c5c;
    }
  }
}
</style>
